var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.25,
    height: 27,
    viewBox: "0 0 29.25 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "trophy-icon",
    d: "M31.641,7.031H27V5.625A1.128,1.128,0,0,0,25.875,4.5H10.125A1.128,1.128,0,0,0,9,5.625V7.031H4.359a.987.987,0,0,0-.984.984h0a11.157,11.157,0,0,0,1.589,6.356,5.725,5.725,0,0,0,3.959,2.834.577.577,0,0,1,.436.345,7.642,7.642,0,0,0,3.593,3.67,13.558,13.558,0,0,0,3.635,1.519.564.564,0,0,1,.436.548v5.681a.564.564,0,0,1-.562.563H11.848a1.008,1.008,0,0,0-1.012.935A.986.986,0,0,0,11.82,31.5H24.166a1.008,1.008,0,0,0,1.013-.935.986.986,0,0,0-.984-1.034H19.554a.564.564,0,0,1-.562-.562V23.295a.564.564,0,0,1,.436-.548,13.889,13.889,0,0,0,3.635-1.519,7.642,7.642,0,0,0,3.593-3.67.563.563,0,0,1,.436-.345,5.725,5.725,0,0,0,3.959-2.834,11.314,11.314,0,0,0,1.575-6.363h0A.987.987,0,0,0,31.641,7.031ZM9,14.808a.283.283,0,0,1-.38.267,4.1,4.1,0,0,1-2.152-2.032A7.4,7.4,0,0,1,5.407,9.612.564.564,0,0,1,5.97,9H8.438A.564.564,0,0,1,9,9.563Zm20.531-1.765a4.1,4.1,0,0,1-2.152,2.032.283.283,0,0,1-.38-.267V9.563A.564.564,0,0,1,27.563,9H30.03a.564.564,0,0,1,.563.612A7.49,7.49,0,0,1,29.531,13.043Z",
    transform: "translate(-3.375 -4.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyIcon);
export default __webpack_public_path__ + "static/media/trophy-icon.7b1ac867416d00d2bd188a975e8867a5.svg";
export { ForwardRef as ReactComponent };